import React, { FC, useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../..";
import Spinner from "../../../components/UI/spinner/Spinner";
import Emptiness from "../../../components/UI/emptiness/Emptiness";
import Timofey from "../../../assets/images/Timofey_avatar.png";
import searchIcon from "../../../assets/icons/search.svg";
import phone from "../../../assets/icons/phone.svg";
import replyEmail from "../../../assets/icons/reply-email.svg";
import comment from "../../../assets/icons/comment.svg";
import service from "../../../assets/icons/notepad.svg";
import Button from "../../../components/UI/button/GgButton";
import { showSuccessToast } from "../../../components/toasts";

const UserEnquiry: FC = () => {
  const [formData, setFormData] = useState<any>({ data: [] });
  const [allData, setAllData] = useState<any>({ data: [] }); 
  const [loading, setLoading] = useState(false);
  const { roles, users, store } = useContext(Context);
  const [adminPermissionData, setAdminPermissionData] = useState<any>()
  
  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "control")?.children?.find((child: any) => child.path === "enquiry")
    setAdminPermissionData(userData)
  };

  async function loadEnquiries() {
    try {
      setLoading(true)
      const response = await users.fetchEnquiry();
      setFormData(response);
      setAllData(response)
      setLoading(false)
    } catch (error) {
      console.error("Error while fetching data:", error);
    }
  }

  useEffect(() => {
    setLoading(true)
    loadEnquiries().then((res) => {
      setLoading(false)
    })
  }, []);

  const deleteEnquiry = async (id: any) => {
   try {
    if (window.confirm("Are you sure you want to delete this Enquiry?")) {
      await users.deleteEnquiry(id).then(() => {
        loadEnquiries()
        showSuccessToast("Enquiry Deleted successfully !")
      })
    }
   } catch (error) {
    console.log(error)
   }
  }

  const searchItems = (searchValue: string) => {
    if (searchValue !== "") {
      const filteredData = allData?.data?.filter((item: any) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      })
      setFormData({ data: filteredData }); // Update usersList state with filtered data
    } else {
      setFormData(allData); // Reset usersList to original data when search is empty
      // loadEnquiries()
    }
  };

  return (
    <form className="body">
      <div className="title">User Enquiry</div>
      <label className="search-bar" htmlFor="search">
        <span className="input-container">
          <span className="icon">
            <img src={searchIcon} alt="search" />
          </span>
          <input
            type="text"
            id="search"
            className="input"
            // value={searchValue}
            onChange={(e) => searchItems(e.target.value)}
            placeholder="Search for reports"
          />
        </span>
      </label>
      <div
        className="r-card-container mainBackgroundBox"
        style={{
          display: loading ? "flex" : "grid",
        }}
      >
        {formData?.data && formData?.data?.length > 0 && !loading ? (
          <>
            {formData?.data?.map((value: any, index: number) => (
              <div className="card" key={index}>
                <ul className="card-info">
                  <li className="card-title" style={{ display: "flex", fontSize: "1.5rem", justifyContent:"space-between"}}>
                    <div className="piece-value">{value.name}</div>
                    <div>
                      <>
                        {adminPermissionData?.delete ? (
                          <Button 
                          label="Delete"
                          onPress={() => deleteEnquiry(value._id)} />
                        ): ""}
                      </>
                    </div>
                  </li>
                  <li className="card-title" style={{ display: "flex"}}>
                    <a href={`mailto:${value.email}`} style={{ display: "flex", alignItems:"center" }}>
                    <span className="icon" style={{marginRight:"0.5rem"}}>
                        <img src={replyEmail} alt="email" />
                      </span>
                      <div className="piece-title">
                        Email</div>
                      <div className="piece-value" style={{ paddingLeft: "2rem" }}>{value.email}</div>
                    </a>
                  </li>
                  <li className="card-title" style={{ display: "flex" }}>
                    <a href={`tel:${value.number}`} style={{ display: "flex", alignItems:"center" }}>
                      <span className="icon" style={{marginRight:"0.5rem"}}>
                        <img src={phone} alt="phone" />
                      </span>
                      <div className="piece-title">Number</div>
                      <div className="piece-value" style={{ paddingLeft: "2rem" }} >{value.number}</div>
                    </a>
                  </li>
                  <li className="card-title" style={{ display: "flex", alignItems:"center" }}>
                      <span className="icon" style={{marginRight:"0.5rem"}}>
                        <img src={service} alt="service" />
                      </span>
                    <div className="piece-title">Service</div>
                    <div className="piece-value" style={{ paddingLeft: "2rem" }}>{value.service}</div>
                  </li>
                  <li className="card-title" style={{ display: "flex", alignItems:"center" }}>
                      <span className="icon" style={{marginRight:"0.5rem"}}>
                        <img src={comment} alt="comment" />
                      </span>
                    <div className="piece-title">Comment</div>
                    <div className="piece-value" style={{ paddingLeft: "2rem" }}>{value.comment}</div>
                  </li>
                </ul>
              </div>
            ))}
          </>
        ) : formData?.data && formData?.data?.length === 0 && !loading ? (
          <Emptiness icon={Timofey} content="There are no User Enquiry
          yet" />
        ) : (
            <Spinner />
        )
        }
      </div>
    </form>
  );
};

export default observer(UserEnquiry);
